import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { GbrechtService, RechtSearchErweitertRequestMeta } from '../../../../core/gb-api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { GbGemeindeSearchMode as GbGemeindeSearchMode } from '../../../../shared/widgets/gb-gemeinde/gbGemeindeSearchMode';
import { GbAmtSearchMode as GbAmtSearchMode } from '../../../../shared/widgets/gb-amt/gbAmtSearchMode';
import { submit } from '../recht.functions';
import { GrundstueckNummerComponent } from '../../../../shared/widgets/grundstueck-nummer/grundstueck-nummer.component';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { BelegComponent } from '../../../../shared/widgets/beleg/beleg.component';
import { Subscription } from 'rxjs';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { StichwortAblaufdatumComponent } from '../../../../shared/widgets/stichwort-ablaufdatum/stichwort-ablaufdatum.component';
import { RechteSelectionComponent } from '../../../../shared/widgets/rechte-selection/rechte-selection.component';
import { HistoryOptionsComponent } from '../../../../shared/widgets/history-options/history-options.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-recht-suche-erweitert',
  templateUrl: './recht-suche-erweitert.component.html',
  styleUrls: ['./recht-suche-erweitert.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    GrundstueckNummerComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    BelegComponent,
    StichwortAblaufdatumComponent,
    RechteSelectionComponent,
    HistoryOptionsComponent,
    TranslatePipe
  ]
})
export class RechtSucheErweitertComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  erweitert: RechtSearchErweitertRequestMeta;

  @Output()
  tabErweitertActive: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(GrundstueckNummerComponent, { static: false })
  private gsNummer: GrundstueckNummerComponent;

  @ViewChild(BelegComponent, { static: false })
  private beleg: BelegComponent;

  @ViewChild('form', { static: false })
  form: NgForm;

  gbAmtSearchMode = GbAmtSearchMode.RECHTE_REGISTER_SEARCH;
  gbGemeindeSearchMode = GbGemeindeSearchMode.RECHTE_REGISTER_SEARCH;

  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private rechtService: GbrechtService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit() {
    this.subscription = this.rechtService.searchRechtErweitertTemplate().subscribe((template) => {
      this.tabErweitertActive.emit(template.mHasRightMassenabfrage.access === 'NONE');
      this.erweitert = this.copyLastRequest(template, SearchMode.searchErweitert);
    });
  }

  onSubmit(): void {
    this.timepointService.resetTimepoint();
    this.stateService.lastRequest = this.erweitert;
    submit(this.form, SearchMode.searchErweitert, this.erweitert, this.router, this.route);
  }

  onReset(): void {
    this.form.reset();
    this.subscription = this.rechtService.searchRechtErweitertTemplate().subscribe((template) => {
      this.erweitert = template;
      this.beleg.onReset();
      this.gsNummer.focus();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
